import { useTranslation } from "react-i18next";
import { HistoriesModalButton } from "../histories/modal-button";
import { HistoryModuleView } from "../histories/module-view";

export function ProjectActivityFeed({ project }) {
  const { t } = useTranslation();

  if (!project?.id) return null;

  return (
    <div className="pv-card">
      <div className="pv-card-head">
        <h2>{t("project.overview.activity.title")}</h2>
        <HistoriesModalButton
          module="project"
          module_param={project.id}
          buttonLayout="link"
        />
      </div>
      <div className="pv-card-pad" style={{ paddingTop: 6 }}>
        <HistoryModuleView
          variant="preview"
          module="project"
          module_param={project.id}
        />
      </div>
    </div>
  );
}

export default ProjectActivityFeed;
